export enum Role {
	ADMIN = 'Administrator',
	USER = 'User',
}

export default Role;
